import { DatapointsEntityType, DatapointIdStandardEnum } from "api/ux/src";
const fundNameAdditionalDimension = { dimension: { standardDatapoint: DatapointIdStandardEnum.FundFundId },
    measure: { name: "FundNameAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.FundFundName } };
const assetNameAdditionalDimension = { dimension: { standardDatapoint: DatapointIdStandardEnum.AssetAssetId },
    measure: { name: "AssetNameAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.AssetAssetName } };
const investorNameAdditionalDimension = { dimension: { standardDatapoint: DatapointIdStandardEnum.FundInvestorId },
    measure: { name: "InvestorNameAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.FundInvestorName } };
const instrumentNameAdditionalDimension = { dimension: { standardDatapoint: DatapointIdStandardEnum.InstrumentInstrumentId },
    measure: { name: "CompanyInstrumentIdAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.InstrumentCompanyInstrumentId } };
const getAdditionalMeasuresAndTheirDimensionsLevel = (entityType, measureLevels) => {
    switch (entityType) {
        case DatapointsEntityType.Manager:
            if (measureLevels.indexOf("Instrument") !== -1) {
                return [
                    fundNameAdditionalDimension,
                    assetNameAdditionalDimension,
                    instrumentNameAdditionalDimension
                ];
            }
            else if (measureLevels.indexOf("Asset") !== -1) {
                return [
                    fundNameAdditionalDimension,
                    assetNameAdditionalDimension
                ];
            }
            else if (measureLevels.indexOf("Fund") !== -1) {
                return [fundNameAdditionalDimension];
            }
            break;
        case DatapointsEntityType.Portfolio:
            if (measureLevels.indexOf("Instrument") !== -1) {
                return [
                    fundNameAdditionalDimension,
                    investorNameAdditionalDimension,
                    assetNameAdditionalDimension,
                    instrumentNameAdditionalDimension
                ];
            }
            else if (measureLevels.indexOf("Asset") !== -1) {
                return [
                    fundNameAdditionalDimension,
                    investorNameAdditionalDimension,
                    assetNameAdditionalDimension
                ];
            }
            else if (measureLevels.indexOf("Fund") !== -1 || measureLevels.indexOf("Cashflows") !== -1) {
                return [
                    fundNameAdditionalDimension,
                    investorNameAdditionalDimension
                ];
            }
            break;
        case DatapointsEntityType.Fund:
            if (measureLevels.indexOf("Instrument") !== -1) {
                return [
                    assetNameAdditionalDimension,
                    instrumentNameAdditionalDimension
                ];
            }
            else if (measureLevels.indexOf("Asset") !== -1) {
                return [assetNameAdditionalDimension];
            }
            else if (measureLevels.indexOf("Fund") !== -1) {
                return [fundNameAdditionalDimension];
            }
            break;
        default:
            return [];
    }
    return [];
};
export const getActualsAndProjectionsAdditionalDatapoints = () => ({
    dimensions: [
        { name: "Fund.FundId", standardDatapoint: DatapointIdStandardEnum.FundFundId },
        { name: "Investor.InvestorId", standardDatapoint: DatapointIdStandardEnum.FundInvestorId }
    ],
    measures: [
        { context: { projectedOnly: true }, name: "FundNameAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.FundFundName },
        { context: { projectedOnly: true }, name: "InvestorNameAdditionalDimension", standardDatapoint: DatapointIdStandardEnum.FundInvestorName }
    ]
});
export const getAdditionalMeasuresAndTheirDimensions = (entityType, measureLevels) => {
    if (!measureLevels.every((e) => e === measureLevels[0] || ((measureLevels[0] === "Instrument" || measureLevels[0] === "Asset") && (e === "Instrument" || e === "Asset")))) {
        return [];
    }
    return getAdditionalMeasuresAndTheirDimensionsLevel(entityType, measureLevels);
};
const flattenColumns = (columns) => columns.reduce((cl, c) => {
    if (c.children) {
        return [...cl, ...c.children, { field: c.field }];
    }
    return [...cl, c];
}, []);
const shouldKeepColumn = (column, groupedList) => !(column.hide === true &&
    column.inspectIncludeHidden !== true &&
    !groupedList.includes(column.field));
const collectFormulaReferencedNames = (measures) => {
    const formulaReferencedNames = new Set();
    measures.forEach((measure) => {
        if (measure.context?.formula) {
            if (measure.context.formula.left) {
                formulaReferencedNames.add(measure.context.formula.left);
            }
            if (measure.context.formula.right) {
                formulaReferencedNames.add(measure.context.formula.right);
            }
        }
    });
    return formulaReferencedNames;
};
const filterMeasures = (measures, colFlat, formulaReferencedNames) => measures.filter((p) => colFlat?.find((c) => c.field === p.name) ||
    (p.name && formulaReferencedNames.has(p.name)));
export const filterHideParamsForInspectData = (columns, params, groupedList) => {
    if (!columns || !params?.[0]?.measures) {
        return;
    }
    const colFlat = flattenColumns(columns).filter((c) => shouldKeepColumn(c, groupedList));
    const formulaReferencedNames = collectFormulaReferencedNames(params[0].measures);
    params[0].measures = filterMeasures(params[0].measures, colFlat, formulaReferencedNames);
};
